'use client'

import { createContext, useContext } from 'react'
import { useTimerService } from '@/core/hooks/use-timer-service'
import type { TimerService } from '@/core/hooks/use-timer-service'

const TimerContext = createContext<TimerService | null>(null)

export function TimerProvider({ children }: { children: React.ReactNode }) {
  const timer = useTimerService()
  return <TimerContext.Provider value={timer}>{children}</TimerContext.Provider>
}

export function useTimer(): TimerService {
  const ctx = useContext(TimerContext)
  if (!ctx) throw new Error('useTimer must be used within TimerProvider')
  return ctx
}
